var jQuery = require('jquery');
var swal = require('sweetalert');
var codes = require('../common/codes.js');

module.exports = BasicEidCard;


/**
 * Class that implements the common behaviour of all specializations
 * 
 */
function BasicEidCard(){
	this._pinDelegate = null;
	this._p = null;
	//pin
	//create 
}


/**
 * This is the public api that every card implementation should implement
 * 
 * @returns {the public api}
 */
BasicEidCard.prototype.getPublicApi = function(){
	var eidCardInstance = this;
	return {
		readCitizenCertificate : function(callback){
			eidCardInstance.readCitizenCertificate(callback)
		},
		readRnData : function(callback){
			eidCardInstance.readRnData(callback);
		},
		readRawRnData : function(callback){
			eidCardInstance.readRawRnData(callback);
		},
		readAddressData : function(callback){
			eidCardInstance.readAddressData(callback);
		},
		readRawAddressData : function(callback){
			eidCardInstance.readRawAddressData(callback);
		},
		readPhoto : function(callback){
			eidCardInstance.readPhoto(callback);
		},
		readRnDataSignature : function(callback){
			eidCardInstance.readRnDataSignature(callback);
		},
		readAddressDataSignature : function(callback){
			eidCardInstance.readAddressDataSignature(callback);
		},
		readRnCertificate : function(callback){
			eidCardInstance.readRnCertificate(callback);
		},
		readRootCertificate : function(callback){
			eidCardInstance.readRootCertificate(callback);
		},
		readAuthenticationCertificate : function(callback){
			eidCardInstance.readAuthenticationCeritifcate(callback);
		},
		readNonRepudationCertificate : function(callback){
			eidCardInstance.readNonRepudationCertificate(callback);
		},
		setPinDelegate : function(pinDelegate){
			eidCardInstance.setPinDelegate(callback);
		},
		stopSigningSession : function(stopSigningSession){
			eidCardInstance.stopSigningSession();
		},
		signRsa : function(dataToSign, callback){
			eidCardInstance.signRsa(dataToSign, callback);
		},
		authenticateRsa: function(dataToSign, callback){
			eidCardInstance.authenticateRsa(dataToSign, callback);
		}
		
	};
}


BasicEidCard.prototype.setPinDelegate = function(pinDelegate){
	this._pinDelegate = pinDelegate;
}

BasicEidCard.prototype.getPinDelegate = function(){
	if(this._pinDelegate == null){
		this._pinDelegate = this.getDefaultPinDelegate();
	}
	return this._pinDelegate;
}

BasicEidCard.prototype.getDefaultPinDelegate = function(){
	if(typeof swal === 'undefined'){
		return null;
	}
	
	var defaultDelegate = {
			
		messages : {
			title : "PIN",
			text : "Please enter the pin of the eID card.",
			inputPlaceholder : "PIN",
			error : {
				emptyPin : "You need to enter your pin.",
				wrongPinTwoTries: "Wrong pin, two tries left.",
				wrongPinOneTry : "Wrong pin, one try left.",
				wrongPinBlocked : "Wrong pin, card blocked.",
				wrongPin : "Wrong pin."
			}
		},

		//TODO: create some properties for the text
		//title, text,...
		
		/**
		 * A function to get the pincode back from the callback function
		 * @param callback 		will be called with :
		 * 							- the pin
		 * 							- an error
		 * @param pinTriesLeft: the number of pin tries left (null if not known)
		 * 
		 */
		getPin : function(callback, pinTriesLeft){
			//no need to hide it when retrying
			
			swal({   
				title: defaultDelegate.messages.title,   
				text: defaultDelegate.messages.text,  
				inputPlaceholder: defaultDelegate.messages.inputPlaceholder ,
				type: "input",   
				showCancelButton: true,   
				closeOnConfirm: false,  
				animation: "slide-from-top",   
				inputType : "password",
				showLoaderOnConfirm : true
				}, 
				function(inputValue){   
					if (inputValue === false){
						console.log("User cancelled pin entry");
						//return user cancelled error
						callback(null, {message : "User cancelled pin entry", errorCode: codes.errorCodes.userCancelled});
						swal.close();
						return false;      
					}
					
					if (inputValue === "") {
						//Show invalid pin length
						//TODO: improve length check
						swal.showInputError(defaultDelegate.messages.error.emptyPin);     
						return false   
					}
					callback(inputValue ,null);
				}
			);
			
			if(pinTriesLeft != null){
				if(pinTriesLeft == 2){
					swal.showInputError(defaultDelegate.messages.error.wrongPinTwoTries)
				}else if(pinTriesLeft == 1){
					swal.showInputError(defaultDelegate.messages.error.wrongPinOneTry)
				}else if(pinTriesLeft == 0){
					swal.showInputError(defaultDelegate.messages.error.wrongPinBlocked)
				}else{
					swal.showInputError(defaultDelegate.messages.error.wrongPin);
				}
			}
		},
		
		/**
		 * Called when correct pin has been entered
		 */
		correctPin : function(){
			swal.close();
		},

		/**
		* The application needs to present the user an error message
		*/
		onError : function(error){
			swal.close();
		},
		
		
		/**
		 * Update the pin delegate with the correct number of pin tries left.
		 * 
		 */
		setPinTriesLeft : function(tries){
			if(tries == 0){
				swal.showInputError(defaultDelegate.messages.error.wrongPinBlocked)
			}
		}
	
	};
	
	return defaultDelegate;

}


BasicEidCard.prototype.pinEnteredPromise = function(tries){
	var pinIsEntered = jQuery.Deferred();
	if(this._p == null){
		this.getPinDelegate().getPin(function(pin , error){
			if(error != null){
				pinIsEntered.reject(error);
			}else{
				pinIsEntered.resolve(pin);
			}
		}, tries);
	}else{
		pinIsEntered.resolve(this._p);
	}
	
	return pinIsEntered.promise();
}


BasicEidCard.prototype.signRsa = function(dataToSign, callback){
	this._sign("signRsaWithPin", dataToSign, callback );

}

BasicEidCard.prototype.authenticateRsa = function(dataToSign, callback){
	this._sign("authenticateRsaWithPin", dataToSign, callback );
}


BasicEidCard.prototype._sign = function(functionName, dataToSign, callback){
	var eidCard = this;
	var pinTries = null;

	var errorCallback = function(error){
		eidCard.getPinDelegate().onError(error);
		callback(null, error);
	}

	
	var pinEntryFunction = function(pin){
		//implement in subclass
		eidCard[functionName](pin, dataToSign, function(signedData, error){
			if(error == null){
				eidCard._p = pin;
				eidCard.getPinDelegate().correctPin();
				//success
				callback(signedData, error);
			}else if(error.errorCode == codes.errorCodes.wrongPinTwoTriesLeft){
				jQuery.when( eidCard.pinEnteredPromise(2) ).then(
						pinEntryFunction,
						errorCallback
				);
				
			}else if(error.errorCode == codes.errorCodes.wrongPinOneTryLeft){
				//eidCard.getPinDelegate().pinTriesLeft(1);
				jQuery.when( eidCard.pinEnteredPromise(1) ).then(
						pinEntryFunction,
						errorCallback
				);
			}else if(error.errorCode == codes.errorCodes.wrongPinCardBlocked){
				eidCard.getPinDelegate().setPinTriesLeft(0);
			}else{
				errorCallback(error);
			}
		});
	};

		
	jQuery.when( this.pinEnteredPromise(pinTries) ).then(
			pinEntryFunction,
			errorCallback
	);
	
}


BasicEidCard.prototype.resetPin = function(){
	this._p = null;
}